__webpack_require__.p = "/pal-scriber/";